module.exports = __webpack_public_path__ + "img/fast-time.ac8ccf31.png";